import { Navigate, Route, Routes } from "react-router-dom";
import { getSession } from "../services/Session";
import { empty } from "../utils/Validation";

export default function PrivateRoute(props){
    return (
        <Routes>
            <Route  path={props.path} element={empty(getSession()) ?<Navigate to="/login" replace />: props.element} />
        </Routes>
    ) 

}
